import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

import ScreenHeading from "../../utilities/ScreenHeading/ScreenHeading";
import ScrollService from "../../utilities/ScrollService";
import Animations from "../../utilities/Animations";
import "./Testimonial.css";
import female from "../../assets/testimonial/female.png";
import male from "../../assets/testimonial/male.png";
import shape from "../../../src/assets/images/shape-bg.png";
import Testimon from "./Testimon";

export default function Testimonial(props) {
  let fadeInScreenHandler = (screen) => {
    if (screen.fadeInScreen !== props.id) return;
    Animations.animations.fadeInScreen(props.id);
  };
  ScrollService.currentScreenFadeIn.subscribe(fadeInScreenHandler);

  const options = {
    loop: true,
    margin: 0,
    nav: true,
    animateIn: "bounceInRight",
    animateOut: "bounceOutRight",
    dots: true,
    autoplay: true,
    smartSpeed: 1000,
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 1,
      },
      1000: {
        items: 3,
      },
    },
  };

  return (
    <div>
      <ScreenHeading
        title={"Testimonial"}
        subHeading={"What My Client Say About Me"}
      />
      <section className="testimonial-section fade-in" id={props.id || ""}>
        <div className="container">
          <div className="row">
            <OwlCarousel
              className="owl-carousel"
              id="testimonial-carousel"
              {...options}
            >
             <Testimon
                review={
                  `It was nice hiring this guy for my e-commerce project. He
                  delivered even more than i can imagine. I recommend him
                  for you.`
                }
                rating={4}
                name={"Sandeep Maheta"}
                role={"Runs a business"}
                photo={male}
              />
               <Testimon
                review={
                  `I had given him commercial web site development task, 
                  He delivered it on time and more than what I was expected. Really nice work. Thank you, Ram.`
                }
                rating={5}
                name={"Suraj Shinde"}
                role={"Runs a business"}
                photo={male}
              />
              <Testimon
                review={
                  `When Ram delivered my website, my head spinned, it was so nice
                  and he implemented every functionality i requested for.
                  Thank you.`
                }
                rating={4}
                name={"Priyanka Raut"}
                role={"Runs a business"}
                photo={female}
              />
            </OwlCarousel>
          </div>
        </div>
      </section>
      <div className="footer-image">
        <img src={shape} alt="Phot0 not responding" />
      </div>
    </div>
  );
}
